import store from 'store'
import { PRE_SIGNUP_SUBSCRIPTION_KEY, POST_SIGNUP_SUBSCRIPTION_KEY } from '../config/api-endpoints'
import { LOCAL_STORAGE_AUTH_KEY } from '../config/constants'
import history from '../routers/history'
import { errorNotification } from './notification-helpers'
import { SIGN_UP_STEPS } from '../config/form-settings'
import { t } from "../i18n";

export const authorizeHeader = (config, idTokenRequired = false, isAuth0Management = false) => {
  const accessToken = store.get((isAuth0Management) ? LOCAL_STORAGE_AUTH_KEY.MGMT_ACCESS_TOKEN : LOCAL_STORAGE_AUTH_KEY.ACCESS_TOKEN)
  const idToken = store.get((isAuth0Management) ? LOCAL_STORAGE_AUTH_KEY.MGMT_ID_TOKEN : LOCAL_STORAGE_AUTH_KEY.ID_TOKEN)

  if (!config) config = { headers: {} }
  if (!config.headers) config.headers = {}

  // Always attach the subscription key
  config.headers['Ocp-Apim-Subscription-Key'] = POST_SIGNUP_SUBSCRIPTION_KEY

  if (!accessToken) {
    console.error('authorizeHeader: access token is missing from local storage')
    errorNotification(t("error_token"))
    history.replace(`/signup/${SIGN_UP_STEPS['failed'].path}`)
    return config
  }

  let token = 'Bearer ' + accessToken
  if (idTokenRequired && idToken) {
    token += ' ' + idToken
  }
  config.headers['Authorization'] = token

  return config
}

export const configureHeaderForEmailVerification = (config) => {
  if (config && config.headers) {
    config.headers['Ocp-Apim-Subscription-Key'] = PRE_SIGNUP_SUBSCRIPTION_KEY
  } else {
    config['headers'] = {
      'Ocp-Apim-Subscription-Key': PRE_SIGNUP_SUBSCRIPTION_KEY
    }
  }
  return config
}
